import CheckIcon from "@mui/icons-material/Check";
import { Stack } from "@mui/material";
import "./styles.scss";

const MinimumRequirement = ({ text }: { text: string }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      className="minimum-requirement"
    >
      <CheckIcon />
      <span className="font-size-3">{text}</span>
    </Stack>
  );
};

export const DesignerMinimumRequirements = () => {
  return (
    <Stack spacing={2}>
      <MinimumRequirement text="A minimum of 3 consecutive years working as a full-time interior designer or decorator." />
      <MinimumRequirement text="A minimum of 4 professional references: You must provide two professional references and two client references." />
      <MinimumRequirement text="A minimum of $150,000 in projected annual revenue, or earned in the previous year." />
      <MinimumRequirement text="Annual Project Capacity: A minimum of 2 larger scale projects or 5 smaller projects or some combination of those numbers. We need to ensure your availability for the homeowners that come to match with you." />
      <MinimumRequirement text="A professional portfolio that includes a minimum of 5 completed projects, 5 concept boards, 5 renders/sketches. The more the better as this provides you with an opportunity to earn passive income with our Designer Files at the Design Membership Level." />
      <MinimumRequirement text="Ability to invest a minimum of $6,000 annually in membership fees, we project between a 3:1 - 5:1 return on your investment." />
      <MinimumRequirement text="Nice to Have: Professional Web site & Social Media Presence." />
    </Stack>
  );
};
